import { render, staticRenderFns } from "./FaqCard.vue?vue&type=template&id=66513668&scoped=true"
import script from "./FaqCard.vue?vue&type=script&lang=js"
export * from "./FaqCard.vue?vue&type=script&lang=js"
import style0 from "./FaqCard.vue?vue&type=style&index=0&id=66513668&prod&scoped=true&lang=scss"
import style1 from "./FaqCard.vue?vue&type=style&index=1&id=66513668&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66513668",
  null
  
)

export default component.exports